import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
// ============================ Directory =============================
export var genDirectoryStyle = function genDirectoryStyle(_ref) {
  var treeCls = _ref.treeCls,
    treeNodeCls = _ref.treeNodeCls,
    directoryNodeSelectedBg = _ref.directoryNodeSelectedBg,
    directoryNodeSelectedColor = _ref.directoryNodeSelectedColor,
    motionDurationMid = _ref.motionDurationMid,
    borderRadius = _ref.borderRadius,
    controlItemBgHover = _ref.controlItemBgHover;
  return _defineProperty({}, "".concat(treeCls).concat(treeCls, "-directory ").concat(treeNodeCls), _defineProperty(_defineProperty(_defineProperty({}, "".concat(treeCls, "-node-content-wrapper"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'static'
  }, "> *:not(".concat(treeCls, "-drop-indicator)"), {
    position: 'relative'
  }), '&:hover', {
    background: 'transparent'
  }), '&:before', {
    position: 'absolute',
    inset: 0,
    transition: "background-color ".concat(motionDurationMid),
    content: '""',
    borderRadius: borderRadius
  }), '&:hover:before', {
    background: controlItemBgHover
  })), "".concat(treeCls, "-switcher, ").concat(treeCls, "-checkbox, ").concat(treeCls, "-draggable-icon"), {
    zIndex: 1
  }), '&-selected', _defineProperty(_defineProperty({}, "".concat(treeCls, "-switcher, ").concat(treeCls, "-draggable-icon"), {
    color: directoryNodeSelectedColor
  }), "".concat(treeCls, "-node-content-wrapper"), {
    color: directoryNodeSelectedColor,
    background: 'transparent',
    '&:before, &:hover:before': {
      background: directoryNodeSelectedBg
    }
  })));
};